import { configureStore } from '@reduxjs/toolkit';
import newsletterReducer from './slices/newsletterSlice';
import contactReducer from './slices/contactSlice';

const store = configureStore({
  reducer: {
    newsletter: newsletterReducer,
    contact: contactReducer,
  },
});

export default store;
